// Team logos mapping for MLB, NBA, and NHL
// Using ESPN CDN for reliable, high-quality team logos

// ESPN logo URL patterns:
// NBA: https://a.espncdn.com/i/teamlogos/nba/500/{abbr}.png
// MLB: https://a.espncdn.com/i/teamlogos/mlb/500/{abbr}.png
// NHL: https://a.espncdn.com/i/teamlogos/nhl/500/{abbr}.png

const NBA_TEAMS = {
  // Team name variations -> ESPN abbreviation
  'hawks': 'atl', 'atlanta hawks': 'atl', 'atlanta': 'atl',
  'celtics': 'bos', 'boston celtics': 'bos', 'boston': 'bos',
  'nets': 'bkn', 'brooklyn nets': 'bkn', 'brooklyn': 'bkn',
  'hornets': 'cha', 'charlotte hornets': 'cha', 'charlotte': 'cha',
  'bulls': 'chi', 'chicago bulls': 'chi', 'chicago': 'chi',
  'cavaliers': 'cle', 'cleveland cavaliers': 'cle', 'cleveland': 'cle', 'cavs': 'cle',
  'mavericks': 'dal', 'dallas mavericks': 'dal', 'dallas': 'dal', 'mavs': 'dal',
  'nuggets': 'den', 'denver nuggets': 'den', 'denver': 'den',
  'pistons': 'det', 'detroit pistons': 'det', 'detroit': 'det',
  'warriors': 'gs', 'golden state warriors': 'gs', 'golden state': 'gs',
  'rockets': 'hou', 'houston rockets': 'hou', 'houston': 'hou',
  'pacers': 'ind', 'indiana pacers': 'ind', 'indiana': 'ind',
  'clippers': 'lac', 'la clippers': 'lac', 'los angeles clippers': 'lac',
  'lakers': 'lal', 'la lakers': 'lal', 'los angeles lakers': 'lal',
  'grizzlies': 'mem', 'memphis grizzlies': 'mem', 'memphis': 'mem',
  'heat': 'mia', 'miami heat': 'mia', 'miami': 'mia',
  'bucks': 'mil', 'milwaukee bucks': 'mil', 'milwaukee': 'mil',
  'timberwolves': 'min', 'minnesota timberwolves': 'min', 'minnesota': 'min', 'wolves': 'min',
  'pelicans': 'no', 'new orleans pelicans': 'no', 'new orleans': 'no',
  'knicks': 'ny', 'new york knicks': 'ny', 'new york': 'ny',
  'thunder': 'okc', 'oklahoma city thunder': 'okc', 'oklahoma city': 'okc', 'okc': 'okc',
  'magic': 'orl', 'orlando magic': 'orl', 'orlando': 'orl',
  '76ers': 'phi', 'philadelphia 76ers': 'phi', 'philadelphia': 'phi', 'sixers': 'phi',
  'suns': 'phx', 'phoenix suns': 'phx', 'phoenix': 'phx',
  'trail blazers': 'por', 'portland trail blazers': 'por', 'portland': 'por', 'blazers': 'por',
  'kings': 'sac', 'sacramento kings': 'sac', 'sacramento': 'sac',
  'spurs': 'sa', 'san antonio spurs': 'sa', 'san antonio': 'sa',
  'raptors': 'tor', 'toronto raptors': 'tor', 'toronto': 'tor',
  'jazz': 'utah', 'utah jazz': 'utah', 'utah': 'utah',
  'wizards': 'wsh', 'washington wizards': 'wsh', 'washington': 'wsh',
};

const MLB_TEAMS = {
  // American League
  'orioles': 'bal', 'baltimore orioles': 'bal', 'baltimore': 'bal',
  'red sox': 'bos', 'boston red sox': 'bos',
  'yankees': 'nyy', 'new york yankees': 'nyy', 'ny yankees': 'nyy',
  'rays': 'tb', 'tampa bay rays': 'tb', 'tampa bay': 'tb',
  'blue jays': 'tor', 'toronto blue jays': 'tor',
  'white sox': 'chw', 'chicago white sox': 'chw',
  'guardians': 'cle', 'cleveland guardians': 'cle',
  'tigers': 'det', 'detroit tigers': 'det',
  'royals': 'kc', 'kansas city royals': 'kc', 'kansas city': 'kc',
  'twins': 'min', 'minnesota twins': 'min',
  'astros': 'hou', 'houston astros': 'hou',
  'angels': 'laa', 'los angeles angels': 'laa', 'la angels': 'laa',
  'athletics': 'oak', 'oakland athletics': 'oak', 'oakland': 'oak', "a's": 'oak',
  'mariners': 'sea', 'seattle mariners': 'sea', 'seattle': 'sea',
  'rangers': 'tex', 'texas rangers': 'tex', 'texas': 'tex',
  // National League
  'braves': 'atl', 'atlanta braves': 'atl',
  'marlins': 'mia', 'miami marlins': 'mia',
  'mets': 'nym', 'new york mets': 'nym', 'ny mets': 'nym',
  'phillies': 'phi', 'philadelphia phillies': 'phi',
  'nationals': 'wsh', 'washington nationals': 'wsh',
  'cubs': 'chc', 'chicago cubs': 'chc',
  'reds': 'cin', 'cincinnati reds': 'cin', 'cincinnati': 'cin',
  'brewers': 'mil', 'milwaukee brewers': 'mil',
  'pirates': 'pit', 'pittsburgh pirates': 'pit', 'pittsburgh': 'pit',
  'cardinals': 'stl', 'st. louis cardinals': 'stl', 'st louis cardinals': 'stl', 'st. louis': 'stl',
  'diamondbacks': 'ari', 'arizona diamondbacks': 'ari', 'arizona': 'ari', 'd-backs': 'ari',
  'rockies': 'col', 'colorado rockies': 'col', 'colorado': 'col',
  'dodgers': 'lad', 'los angeles dodgers': 'lad', 'la dodgers': 'lad',
  'padres': 'sd', 'san diego padres': 'sd', 'san diego': 'sd',
  'giants': 'sf', 'san francisco giants': 'sf', 'san francisco': 'sf',
};

const NHL_TEAMS = {
  'ducks': 'ana', 'anaheim ducks': 'ana', 'anaheim': 'ana',
  'coyotes': 'ari', 'arizona coyotes': 'ari', 'utah hockey club': 'utah',
  'bruins': 'bos', 'boston bruins': 'bos',
  'sabres': 'buf', 'buffalo sabres': 'buf', 'buffalo': 'buf',
  'flames': 'cgy', 'calgary flames': 'cgy', 'calgary': 'cgy',
  'hurricanes': 'car', 'carolina hurricanes': 'car', 'carolina': 'car',
  'blackhawks': 'chi', 'chicago blackhawks': 'chi',
  'avalanche': 'col', 'colorado avalanche': 'col',
  'blue jackets': 'cbj', 'columbus blue jackets': 'cbj', 'columbus': 'cbj',
  'stars': 'dal', 'dallas stars': 'dal',
  'red wings': 'det', 'detroit red wings': 'det',
  'oilers': 'edm', 'edmonton oilers': 'edm', 'edmonton': 'edm',
  'panthers': 'fla', 'florida panthers': 'fla', 'florida': 'fla',
  'kings': 'la', 'los angeles kings': 'la', 'la kings': 'la',
  'wild': 'min', 'minnesota wild': 'min',
  'canadiens': 'mtl', 'montreal canadiens': 'mtl', 'montreal': 'mtl', 'habs': 'mtl',
  'predators': 'nsh', 'nashville predators': 'nsh', 'nashville': 'nsh',
  'devils': 'njd', 'new jersey devils': 'njd', 'new jersey': 'njd',
  'islanders': 'nyi', 'new york islanders': 'nyi', 'ny islanders': 'nyi',
  'rangers': 'nyr', 'new york rangers': 'nyr', 'ny rangers': 'nyr',
  'senators': 'ott', 'ottawa senators': 'ott', 'ottawa': 'ott',
  'flyers': 'phi', 'philadelphia flyers': 'phi',
  'penguins': 'pit', 'pittsburgh penguins': 'pit',
  'sharks': 'sj', 'san jose sharks': 'sj', 'san jose': 'sj',
  'kraken': 'sea', 'seattle kraken': 'sea',
  'blues': 'stl', 'st. louis blues': 'stl', 'st louis blues': 'stl',
  'lightning': 'tb', 'tampa bay lightning': 'tb',
  'maple leafs': 'tor', 'toronto maple leafs': 'tor', 'leafs': 'tor',
  'canucks': 'van', 'vancouver canucks': 'van', 'vancouver': 'van',
  'golden knights': 'vgk', 'vegas golden knights': 'vgk', 'vegas': 'vgk',
  'capitals': 'wsh', 'washington capitals': 'wsh',
  'jets': 'wpg', 'winnipeg jets': 'wpg', 'winnipeg': 'wpg',
};

/**
 * Get team logo URL for a given team name and sport
 * @param {string} teamName - The team name (e.g., "Cleveland Guardians", "Cavaliers", "Heat")
 * @param {string} sport - The sport (NBA, MLB, NHL)
 * @returns {string|null} - ESPN CDN logo URL or null if not found
 */
export const getTeamLogo = (teamName, sport) => {
  if (!teamName || !sport) return null;
  
  const normalizedName = teamName.toLowerCase().trim();
  const sportUpper = sport.toUpperCase();
  
  let abbr = null;
  let league = null;
  
  switch (sportUpper) {
    case 'NBA':
    case 'NCAAB': // For college, we won't have logos but won't break
      abbr = NBA_TEAMS[normalizedName];
      league = 'nba';
      break;
    case 'MLB':
      abbr = MLB_TEAMS[normalizedName];
      league = 'mlb';
      break;
    case 'NHL':
      abbr = NHL_TEAMS[normalizedName];
      league = 'nhl';
      break;
    default:
      return null;
  }
  
  if (!abbr) return null;
  
  return `https://a.espncdn.com/i/teamlogos/${league}/500/${abbr}.png`;
};

/**
 * Parse matchup string and extract team names
 * Handles formats like: "Team A @ Team B", "Team A vs Team B", "Team A vs. Team B"
 * @param {string} matchup - The matchup string
 * @returns {Object} - { team1: string, team2: string } or null
 */
export const parseMatchup = (matchup) => {
  if (!matchup) return null;
  
  // Try different separators
  const separators = [' @ ', ' vs ', ' vs. ', ' VS ', ' VS. ', ' at '];
  
  for (const sep of separators) {
    if (matchup.includes(sep)) {
      const parts = matchup.split(sep);
      if (parts.length === 2) {
        return {
          team1: parts[0].trim(),
          team2: parts[1].trim()
        };
      }
    }
  }
  
  return null;
};

/**
 * Get both team logos for a matchup
 * @param {string} matchup - The matchup string (e.g., "Cavaliers @ Heat")
 * @param {string} sport - The sport (NBA, MLB, NHL)
 * @returns {Object} - { team1Logo: string|null, team2Logo: string|null, team1: string, team2: string }
 */
export const getMatchupLogos = (matchup, sport) => {
  const teams = parseMatchup(matchup);
  
  if (!teams) {
    return { team1Logo: null, team2Logo: null, team1: null, team2: null };
  }
  
  return {
    team1: teams.team1,
    team2: teams.team2,
    team1Logo: getTeamLogo(teams.team1, sport),
    team2Logo: getTeamLogo(teams.team2, sport)
  };
};

export default {
  getTeamLogo,
  parseMatchup,
  getMatchupLogos
};
